// import $ from 'jquery';
import { getOptionsFromDataset } from '../../util/dataset.js';

/**
 * Handle element annotation
 *
 * @type {AsyncDynamicInitFunction<HTMLElement>}
 */
export default async ($collection) => {

	const { annotate } = await import('rough-notation');

	for (const element of $collection) {
		const options = getOptionsFromDataset(element, 'annotate');
		const annotation = annotate(element, { type: 'underline', ...options });
		annotation.show();
	}
};